import React from 'react'
import ReactIcon from 'react-icons-kit';

const Bolt = React.lazy(() => import('@mui/icons-material/Bolt'))
const Phone = React.lazy(() => import('@mui/icons-material/LocalPhoneOutlined'))
const Price = React.lazy(() => import('@mui/icons-material/MonetizationOnOutlined'))
const MapIcon = React.lazy(() => import('@mui/icons-material/MapOutlined'))
const People = React.lazy(() => import('@mui/icons-material/People'))
const Reviews = React.lazy(() => import('@mui/icons-material/Reviews'))
const TrendingUp = React.lazy(() => import('@mui/icons-material/TrendingUp'))
const Storefront = React.lazy(() => import('@mui/icons-material/Storefront'))
const WebIcon = React.lazy(() => import('@mui/icons-material/ArrowOutwardOutlined'))

// FIXME: this weight to the page for just one icon
import {yelp} from 'react-icons-kit/fa/yelp'

const Icon = ({
  type,
  iconSize = '1.4rem',
  padding = '0.4rem',
  ...props}) => {

  const renderIcon = (type) => {
    switch (type) {
      case 'bolt':
        return <Bolt/>
      case 'map':
        return <MapIcon />
      case 'business':
        return <Storefront />
      case 'phone':
        return <Phone />
      case 'people':
        return <People />
      case 'reviews':
        return <Reviews />
      case 'price':
        return <Price />
      case 'trending':
        return <TrendingUp />
      case 'web':
        return <WebIcon />
      case 'yelp':
        return <ReactIcon
            icon={yelp}
            size={iconSize}
            style={{ padding: padding }}/>
      default:
        return <Phone />
    }
  }

  return(
    <React.Suspense>
      <span className='icon' style={{ marginRight: '1rem' }}>
        {renderIcon(type)}
      </span>
    </React.Suspense >
  )
}

export default Icon
